import { render, staticRenderFns } from "./NationPrepClass.vue?vue&type=template&id=c2aed3dc&scoped=true"
import script from "./NationPrepClass.vue?vue&type=script&lang=js"
export * from "./NationPrepClass.vue?vue&type=script&lang=js"
import style0 from "./NationPrepClass.vue?vue&type=style&index=0&id=c2aed3dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aed3dc",
  null
  
)

export default component.exports